import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { fallbackContent } from '../hooks/useContent';

const WhyChoose = ({ why = fallbackContent.whyChoose, industries = fallbackContent.industries }) => {
  return (
    <section className="py-20 lg:py-28 bg-[#f5f5f8]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-16">
        <div>
          <p className="section-label text-[#c9a227] mb-3">Why Choose Us</p>
          <h2 className="font-display font-bold text-[#12263f] text-3xl lg:text-4xl">Reasons clients stay with us.</h2>
          <div className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-4">
            {why.map((item, i) => (
              <div key={i} className="flex items-center gap-3">
                <CheckCircle2 size={18} className="text-[#12263f] shrink-0" />
                <span className="text-[15px] text-gray-700">{item}</span>
              </div>
            ))}
          </div>
        </div>

        <div>
          <p className="section-label text-[#c9a227] mb-3">Industries We Serve</p>
          <h2 className="font-display font-bold text-[#12263f] text-3xl lg:text-4xl">Trusted across sectors.</h2>
          <div className="mt-8 flex flex-wrap gap-3">
            {industries.map((ind, i) => (
              <span key={i} className="px-4 py-2 rounded-full bg-white border border-gray-200 text-sm text-gray-700 hover:border-[#12263f] hover:text-[#12263f] transition-colors cursor-default">{ind}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
